import { render, staticRenderFns } from "./report-cake.vue?vue&type=template&id=b47236ca&"
import script from "./report-cake.vue?vue&type=script&lang=js&"
export * from "./report-cake.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports